import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿El sitio es mío?',
    a: 'Sí, absolutamente. Una vez finalizado el proyecto y cancelado el pago, la página web es de tu propiedad total. No cobramos mensualidades por el diseño.'
  }, {
    q: '¿Funciona en celulares?',
    a: "100%. Diseñamos con un enfoque 'Mobile-First', lo que significa que tu web se verá y funcionará perfectamente en cualquier dispositivo móvil, tablet o computadora."
  }, {
    q: '¿Qué necesito para empezar?',
    a: 'Solo necesitamos información básica de tu negocio: qué servicios ofrecés, datos de contacto, tu logo (si tenés) y algunas fotos. Si te falta algo, te ayudamos a resolverlo.'
  }, {
    q: '¿Cuánto demora?',
    a: 'El tiempo estimado de entrega es de entre 5 y 10 días hábiles, dependiendo de la complejidad del proyecto y de la rapidez con la que nos envíes la información necesaria.'
  }, {
    q: '¿Cómo es el pago?',
    a: 'Trabajamos con un anticipo del 50% para iniciar el proyecto y el 50% restante se abona una vez que la web está terminada y lista para publicarse.'
  }, {
    q: '¿Incluye cambios?',
    a: 'Sí, incluimos una instancia de revisión donde podés solicitar ajustes de diseño o textos para asegurarnos de que el resultado final sea exactamente lo que buscás.'
  }];
  return <section id="faq" className="py-24 relative z-10 bg-dark-surface/30 border-t border-white/5" data-id="element-36">
      <div className="max-w-3xl mx-auto px-6" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-38">
          <h2 className="text-3xl md:text-5xl font-bold" data-id="element-39">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-40">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-white/10 rounded-2xl overflow-hidden bg-dark-bg" data-id="element-41">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/5 transition-colors" data-id="element-42">
                <span className="font-bold text-lg pr-8" data-id="element-43">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="text-neon-blue flex-shrink-0" data-id="element-44">
                  <ChevronDown size={24} data-id="element-45" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-46">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-47">
                    <div className="px-6 pb-6 text-silver border-t border-white/5 pt-4" data-id="element-48">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};